import React from 'react';
import { ListItem } from '@producepay/pp-ui';

export const MenuItem = props => {
  return <ListItem className="hover:text-white hover:bg-primary" {...props} />;
};
